const app = {
  version: process.env.REACT_APP_VERSION,
  buildId: process.env.REACT_APP_BUILD_ID,
  environment: process.env.NODE_ENV
};

const api = {
  baseUrl: process.env.REACT_APP_API_BASE_URL
};

const appInsights = {
  connectionString: process.env.REACT_APP_INSIGHTS_CONN_STRING
};

export { app, api, appInsights };
